import React, { useContext } from 'react';
import { FilterContext } from '../../context/Filter';

const Valuecards = ({ icon, heading, value, colors, percentage }) => {
  const { open } = useContext(FilterContext); // ✅ move inside function body

  return (
    <div className={`md:flex flex-col md:flex-row md:justify-between items-center gap-2 m-1 p-4 bg-white rounded-lg shadow-[0_0_4px_1px_rgba(0,0,0,0.1)] ring-2 ring-gray-300 w-96 md:w-full `}>

      {/* Icon */}
      <div className="text-3xl">{icon}</div>

      {/* Heading */}
      <div className="text-center md:text-left text-xs md:text-sm font-semibold">
        {heading}
      </div>

      {/* Value + Percentage */}
      <div className="flex flex-col items-center md:items-end">
        <div className={`font-bold text-sm md:text-base ${colors}`}>
          {value}
        </div>
        <div className={`text-xs font-semibold ${colors}`}>
          {percentage}
        </div>
      </div>
    </div>
  );
};

export default Valuecards;
